import { RefObject, useEffect, useLayoutEffect } from 'react';
import { useBooleanState } from 'react-use-object-state';
import { useDebouncedCallback } from 'use-debounce';

interface Props {
  ref: RefObject<HTMLElement>;
}

export default function useExpandable({ ref }: Props) {
  const expandable = useBooleanState(false);

  const computeIsElementExpandable = () => {
    if (ref.current && ref.current.offsetWidth < ref.current.scrollWidth) {
      expandable.setTrue();
    } else {
      expandable.setFalse();
    }
  };

  const [debouncedComputeIsElementExpandable] = useDebouncedCallback(
    computeIsElementExpandable,
    500
  );

  useLayoutEffect(() => {
    computeIsElementExpandable();
  });

  useEffect(() => {
    window.addEventListener('resize', debouncedComputeIsElementExpandable);
    return () => {
      window.removeEventListener('resize', debouncedComputeIsElementExpandable);
    };
  }, []);

  return expandable.state;
}
